import React, { useMemo } from "react";
import { Tag } from "antd";
import { TagProps } from "antd/lib/tag";
import style from "./index.module.scss";
import { strCut } from "../../../../../utils/common";

interface CustomTagProps extends TagProps {
    children: string;
}

export default function CustomTag(props: CustomTagProps) {
    const text = useMemo(() => strCut(props.children, 20), [props.children]);
    return (
        <Tag
            {...props}
            closable
            className={style.root}
            visible
            onClose={props.onClose}
            title={props.children}>
            {text}
        </Tag>
    );
}
